import { useCallback } from 'react';
import { DiscountCodeData } from '@app/domain/model/eshop/transport/DiscountCodeData';
import { validateDiscountCode } from '@app/service/eshop/checkout/actions/validateDiscountCode';
import { ProductCode } from '@app/domain/model/eshop/transport/ProductCode';

export function useHomeInsuranceDiscounts(
    discountCodeData: DiscountCodeData,
    setDiscountCodeData: (data: DiscountCodeData) => void,
) {
    const handleDiscountCode = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setDiscountCodeData({
                ...discountCodeData,
                discountCode: e.target.value,
                isInvalid: false,
                isSuccess: false,
                validTravelCode: undefined,
            });
        },
        [discountCodeData, setDiscountCodeData],
    );

    const handleApplyDiscountClick = useCallback(async () => {
        const discountCodeResult = await validateDiscountCode(discountCodeData.discountCode, ProductCode.Home, '');

        const isTravelValid = discountCodeResult?.isValid === true;

        if (isTravelValid) {
            setDiscountCodeData({
                ...discountCodeData,
                isSuccess: true,
                isInvalid: false,
                validTravelCode: discountCodeData.discountCode,
            });
        } else {
            setDiscountCodeData({
                ...discountCodeData,
                isSuccess: false,
                isInvalid: true,
                validTravelCode: undefined,
            });
        }
    }, [discountCodeData, setDiscountCodeData]);

    return {
        handleDiscountCode,
        handleApplyDiscountClick,
    };
}
